import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import {
    set,
    update as updateMessages
} from "@/redux/modules/value/messages/messages.module";
import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";
import { getValueState } from "@/redux/utils";

import { getMessages } from "./messages.selectors";
import { $MessagesModuleName } from "./messages.types";
export type MessagePostFix = {
    onClick?: () => void;
    text: string;
};

export type Message = {
    id: string;
    text: any;
    status:
        | "primary"
        | "secondary"
        | "success"
        | "danger"
        | "warning"
        | "info"
        | "light"
        | "dark";
    dismissible: boolean;
    postFix?: MessagePostFix;
    activeScroll?: boolean;
    title?: string;
};

export const broadcastMessage = (message: Message) => {
    const store = window.storeManager;
    const state = store.getState();
    const messageArray = getValueState(state, $MessagesModuleName) || [];

    // Check if we already have a message with the corresponding ID
    const msg = messageArray.find((element: any) => element.id === message.id);

    if (msg && message.id !== "api-message") {
        // Yes? Change the values
        msg.id = message.id;
        msg.text = message.text;
        msg.status = message.status;
        msg.dismissible = message.dismissible;
        msg.postFix = message.postFix;
    } else {
        //No? Add the message to the array
        messageArray.push(message);
    }

    // after showing carts merged message, don't show it again
    SessionStorage.removeItem("carts_merged");

    //Update our redux state
    store.dispatch(updateMessages(messageArray));
};

export const clearMessages = () => {
    const store = window.storeManager;
    const messages = getMessages(store.getState()) || [];
    if (getMessages(store.getState()).length === 0) {
        return;
    }
    // Tijdelijk tot Quiévrechain volledig overgegeven is aan Mr. Bricolage
    const newMessages = messages.filter(
        (m) =>
            m.id === "api-message" &&
            m.text.length > 0 &&
            m.text[0].code === "QUIEVRECHAIN_HOME_DELIVERY"
    );

    store.dispatch(set(newMessages));
};

export const clearMessageById = (id: string) => {
    const store = window.storeManager;
    const messages = getMessages(store.getState());
    if (messages.length === 0) {
        return;
    }
    const messagesWithoutId = messages.filter((m: any) => m.id !== id);

    store.dispatch(set(messagesWithoutId));
};

export const clearMessagesExcludingIds = (ids: Array<string>) => {
    const store = window.storeManager;
    const messages = getMessages(store.getState());
    if (messages.length === 0) {
        return;
    }

    const messagesWithId = messages.filter((m: any) =>
        ids.some((i) => i === m.id)
    );

    store.dispatch(set(messagesWithId));
};

export const getUrlErrorMessages = (): string[] => {
    const urlParams = new URL(window.location.href).searchParams;
    const errorMessage = urlParams.get("ci-m");

    return (
        (errorMessage && [
            translateWithoutContext(`apiMessages.title.${errorMessage}`)
        ]) ||
        []
    );
};
